import { inject, Injectable } from "@angular/core";


import { Actions, createEffect, ofType } from "@ngrx/effects";

import { map, mergeMap, pipe } from "rxjs";

import { TaxService } from "../../../services/settings/tax.service";

import { loadTaxType, loadTaxTypeSuccess } from "./tax.action";
import { TaxType } from "../model/tax.model";

@Injectable()
export class TaxTypeEffect {

    action$ = inject(Actions)

    constructor(private taxTypeService: TaxService) { }

    loadTaxType$ = createEffect(() =>
        this.action$.pipe(
            ofType(loadTaxType),
            mergeMap(() =>
              this.taxTypeService.getTax().pipe(map((res: { data: { taxRates: TaxType[] } }) =>
                    loadTaxTypeSuccess({taxType: res.data.taxRates}),
                ),
                //error handle here
                )
            )
        )
    )
}
